require('./lib/bootstrap');
require('./lib/adminlte');
require('./lib/jquery.amaran');
(function($, window, document, undefined) {

    'use strict';

    $(function() {
        /*
            fix vertical when not overflow
            call fullscreenFix() if .fullscreen content changes
        */
        // function fullscreenFix() {
        //     var h = $('body').height();
        //     // set .fullscreen height
        //     $('.content-b').each(function() {
        //         if ($(this).innerHeight() > h) {
        //             $(this).closest('.fullscreen').addClass('overflow');
        //         }
        //     });
        // }
        // $(window).resize(fullscreenFix);
        // fullscreenFix();

        // /* resize background images */
        // function backgroundResize() {
        //     var windowH = $(window).height();
        //     $('.background').each(function() {
        //         var path = $(this);
        //         // variables
        //         var contW = path.width();
        //         var contH = path.height();
        //         var imgW = path.attr('data-img-width');
        //         var imgH = path.attr('data-img-height');
        //         var ratio = imgW / imgH;
        //         // overflowing difference
        //         var diff = parseFloat(path.attr('data-diff'));
        //         diff = diff ? diff : 0;
        //         // remaining height to have fullscreen image only on parallax
        //         var remainingH = 0;
        //         if (path.hasClass('parallax')) {
        //             //var maxH = contH > windowH ? contH : windowH;
        //             remainingH = windowH - contH;
        //         }
        //         // set img values depending on cont
        //         imgH = contH + remainingH + diff;
        //         imgW = imgH * ratio;
        //         // fix when too large
        //         if (contW > imgW) {
        //             imgW = contW;
        //             imgH = imgW / ratio;
        //         }
        //         //
        //         path.data('resized-imgW', imgW);
        //         path.data('resized-imgH', imgH);
        //         path.css('background-size', imgW + 'px ' + imgH + 'px');
        //     });
        // }
        // $(window).resize(backgroundResize);
        // $(window).focus(backgroundResize);
        // backgroundResize();
        //
        // var background = {
        //     'pegimane100': 'bg-1.jpg',
        //     'travelmate': 'bg-2.jpg',
        //     'travelreservations': 'bg-3.jpg',
        //     'helpline': 'bg-4.jpg',
        //     'pegimane': 'bg-5.jpg',
        //     'customizedprofile': 'bg-6.jpg',
        //     'pegimanegames': 'bg-7.jpg',
        //     'photoalbums': 'bg-8.jpg',
        //     'pegimanetips': 'bg-11.jpg',
        //     'memories': 'bg-10.jpg'
        // };
        //
        // var timeout;
        // var tabChange = function() {
        //     var tabs = $('.nav-tabs > li');
        //     var active = tabs.filter('.active');
        //     var next = active.next('li').length ? active.next('li').find('a') : tabs.filter(':first-child').find('a');
        //
        //     var getAnchor = next.attr('href'),
        //     getID = getAnchor.substr(1);
        //
        //     // Use the Bootsrap tab show method
        //     next.tab('show');
        //     $('#main').css('background-image', 'url(/images/' + background[getID] + ')');
        //
        //     clearTimeout(timeout);
        // };
        //
        // // Tab Cycle function
        // var tabCycle = setInterval(tabChange, 4000);
        //
        // $('.nav-tabs li a').click(function() {
        //
        //     clearTimeout(timeout);
        //     var getAnchor = $(this).attr('href'),
        //         getID = getAnchor.substr(1);
        //
        //     $('#main').css('background-image', 'url(/images/' + background[getID] + ')');
        //
        //     // // Stop the cycle
        //     clearInterval(tabCycle);
        //
        //     // // Start the cycle again in a predefined amount of time
        //     timeout = setTimeout(function () {
        //         tabCycle = setInterval(tabChange, 4000);
        //     }, 10000);
        // });

        var getNavHeight = $('nav').height(),
            getTitleHeight = $('#sign-form h3').height(),
            getWindowHeight = $(window).height(),
            additionalHeight = 40,
            calculateHeight = getWindowHeight - (getNavHeight + getTitleHeight + additionalHeight);

            console.log(getNavHeight, getTitleHeight, getWindowHeight);
        // $('#mobile #signin').css('margin-top', (10 + calculateHeight) + 'px');


        // $('.login-button').click(function(){
        //     $('#main > section').animate({scrollTop: (getTitleHeight + additionalHeight + calculateHeight) + 'px'}, 800);
        // });

        // var setTextFooter = function () {
        //     if ($(window).height() >= $('.content-a').height()) {
        //         $('.text-footer').css('position', 'fixed');
        //     } else {
        //         $('.text-footer').css('position', 'initial');
        //     }
        // };
        //
        // setTextFooter();
        // $(window).resize(setTextFooter);
        $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-tokenxx"]').attr('content')
            }
        });

        $("#password").keyup(function (event) {
            var $value = $("#password").val();
            var $lang  = $("#lang").val();
            $lang  = $lang == undefined ? 'en' : $lang;
            if ($value != '') {
                checkPassword($value, $lang);
            }
        });

        function checkPassword($value, $lang) {
            $.ajax({
                url: "/credential_checker",
                data: { password: $value, lang: $lang },
                type: "post",
                success: function(data) {
                    if (data.status == 'error') {
                        $(".password-warning").find('span').text('* '+data.msg)
                        $(".password-warning").show();
                    } else {
                        $(".password-warning").hide();
                    }
                },
                error: function(xhr, status, error) {
                    if (error) {
                        alert('Internal server error');
                    }
                }
            });
        };

    });

})(jQuery, window, document);



//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/index.js
// module id = 1
// module chunks = 0